// extracted by mini-css-extract-plugin
module.exports = {"macAlert":"ConfigurationAsidePanel__macAlert","requiresSupervision":"ConfigurationAsidePanel__requiresSupervision"};